import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useDocTitle(key) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.title = t(key);
  }, [t, i18n.language, key]);
}
